import { CityLandingPageEventSerializer } from "@app-contexts/public/features/event-detail/data/types/events";
import { PublicBaseEventSerializer } from "@shared/modules/events/types/public";
import { createRichEventSchema } from "@app-contexts/public/features/event-detail/utils/event-schema";
import Script from "next/script";

type EventSchemaProps = {
  event: PublicBaseEventSerializer | CityLandingPageEventSerializer;
};

export const EventSchema: React.FC<EventSchemaProps> = ({ event }) => {
  const evt = event;
  evt.eventSchema = createRichEventSchema(evt);
  return (
    <Script
      key={evt.id}
      type="application/ld+json"
      id={`event-schema-${evt.name}`}
      data-testid="event-schema-script"
    >
      {evt.eventSchema}
    </Script>
  );
};

export default EventSchema;
